import BikeCard from "../components/BikeCard";
import SEO from "../components/SEO";
import "../styles/bikes.css";

export default function Bikes() {
  const bikes = [
    {
      name: "Royal Enfield Classic 350",
      price: "800",
      image:
        "https://www.royalenfield.com/content/dam/royal-enfield/classic-350/gallery/thumbnail/gallery-7.jpg",
    },
    {
      name: "Hunter 350",
      price: "900",
      image:
        "https://autoengina.com/cdn/shop/collections/hunter-350-collection_jpg.jpg?v=1761025786",
    },
    {
      name: "Honda Activa",
      price: "300",
      image:
        "https://i.cdn.newsbytesapp.com/images/l200_30851597390379.jpg",
    },
  ];

  const breadcrumbs = [
    {
      name: "Home",
      url: "https://vkbikeonrent.in/",
    },
    {
      name: "Bike & Scooty Rental",
      url: "https://vkbikeonrent.in/bikes",
    },
  ];

  const faqItems = [
    {
      question: "Where can I rent a bike or scooty in Udaipur?",
      answer:
        "VK Bike On Rent provides bike and scooty rental options in Udaipur. The business is located near Jagdish Chowk, and customers can contact the team to check current vehicle availability and booking details.",
    },
    {
      question: "How much does it cost to rent a bike in Udaipur?",
      answer:
        "Rental prices depend on the vehicle. The currently listed options start from ₹300 per day for Honda Activa, ₹800 per day for Royal Enfield Classic 350 and ₹900 per day for Hunter 350. Confirm the current price and availability before booking.",
    },
    {
      question: "Can I book a rental bike through WhatsApp?",
      answer:
        "Yes. You can contact VK Bike On Rent through WhatsApp to enquire about vehicle availability, rental pricing and booking requirements.",
    },
    {
      question: "Is scooty rental available in Udaipur?",
      answer:
        "Yes. Honda Activa and other scooter options may be available for rental. Contact VK Bike On Rent to confirm the current availability for your dates.",
    },
    {
      question: "Where can I explore Udaipur by rental bike?",
      answer:
        "A rental bike or scooty can be convenient for exploring places around Udaipur such as City Palace, Lake Pichola, Jagdish Temple and other local attractions. Check local traffic, parking and access conditions before travelling.",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <>
      {/* =====================================================
          PAGE SEO
      ====================================================== */}

      <SEO
        title="Bike & Scooty Rental in Udaipur | VK Bike On Rent"
        description="Rent bikes and scooters in Udaipur with VK Bike On Rent. Check Royal Enfield Classic 350, Hunter 350, Honda Activa and other available rental options near Jagdish Chowk."
        canonical="https://vkbikeonrent.in/bikes"
        breadcrumbs={breadcrumbs}
        schema={faqSchema}
      />

      <main className="bikes-page">

        {/* =================================================
            PAGE INTRODUCTION
        ================================================== */}

        <section
          className="section"
          aria-labelledby="bikes-page-title"
        >
          <header className="page-header">

            <h1 id="bikes-page-title">
              Bike & Scooty Rental in Udaipur
            </h1>

            <p>
              Explore Udaipur at your own pace with bikes and
              scooters available for rent from VK Bike On Rent.
              Choose from the available rental options below
              and contact us to confirm current availability,
              pricing and booking requirements.
            </p>

          </header>

          {/* =================================================
              AVAILABLE VEHICLES
          ================================================== */}

          <section
            className="bike-listing"
            aria-labelledby="available-bikes-title"
          >

            <header>
              <h2 id="available-bikes-title">
                Available Bikes & Scooters
              </h2>

              <p>
                Browse our currently listed rental vehicles
                and contact VK Bike On Rent before booking to
                confirm availability for your travel dates.
              </p>
            </header>

            <div className="bike-grid">

              {bikes.map((bike) => (
                <BikeCard
                  key={bike.name}
                  name={bike.name}
                  price={bike.price}
                  image={bike.image}
                />
              ))}

            </div>

          </section>

          {/* =================================================
              WHY RENT A BIKE
          ================================================== */}

          <section
            className="bike-seo-content"
            aria-labelledby="why-rent-bike-title"
          >

            <h2 id="why-rent-bike-title">
              Why Rent a Bike or Scooty in Udaipur?
            </h2>

            <p>
              Renting a bike or scooty can be a convenient way
              to explore Udaipur, especially when you want
              flexibility for short city trips and sightseeing.
              Two-wheelers can make it easier to travel between
              popular areas and explore the city's streets at
              your own pace.
            </p>

            <p>
              VK Bike On Rent offers different vehicle options
              depending on availability. Whether you are looking
              for a motorcycle for sightseeing or a scooty for
              convenient local travel, contact us before booking
              to confirm the vehicle, price and rental terms.
            </p>

          </section>

          {/* =================================================
              POPULAR PLACES
          ================================================== */}

          <section
            className="bike-seo-content"
            aria-labelledby="udaipur-places-title"
          >

            <h2 id="udaipur-places-title">
              Explore Udaipur by Rental Bike
            </h2>

            <p>
              A rental bike or scooty can be useful for exploring
              popular areas of Udaipur. Depending on your route,
              you may visit places such as:
            </p>

            <ul>
              <li>City Palace</li>
              <li>Lake Pichola</li>
              <li>Jagdish Temple</li>
              <li>Gangaur Ghat</li>
              <li>Fateh Sagar Lake</li>
              <li>Saheliyon Ki Bari</li>
            </ul>

            <p>
              Check local traffic, parking rules, road conditions
              and attraction access requirements before starting
              your ride.
            </p>

          </section>

          {/* =================================================
              HOW BOOKING WORKS
          ================================================== */}

          <section
            className="bike-seo-content"
            aria-labelledby="booking-process-title"
          >

            <h2 id="booking-process-title">
              How to Book a Rental Bike in Udaipur
            </h2>

            <ol>
              <li>
                Choose your preferred bike or scooty.
              </li>

              <li>
                Contact VK Bike On Rent on WhatsApp.
              </li>

              <li>
                Share your required rental date and vehicle.
              </li>

              <li>
                Confirm current availability and rental price.
              </li>

              <li>
                Complete the booking process as instructed by
                the rental provider.
              </li>
            </ol>

          </section>

          {/* =================================================
              BOOKING CTA
          ================================================== */}

          <section
            className="bike-booking-cta"
            aria-labelledby="booking-cta-title"
          >

            <h2 id="booking-cta-title">
              Need a Bike or Scooty in Udaipur?
            </h2>

            <p>
              Contact VK Bike On Rent to check current
              availability, pricing and booking details.
            </p>

            <a
              href="https://wa.me/919983765215?text=Hi%20VK%20Bike%20On%20Rent%2C%20I%20want%20to%20enquire%20about%20bike%20or%20scooty%20rental%20in%20Udaipur."
              target="_blank"
              rel="noopener noreferrer"
              className="bike-booking-btn"
              aria-label="Enquire about bike or scooty rental in Udaipur on WhatsApp"
            >
              📲 Check Availability on WhatsApp
            </a>

          </section>

          {/* =================================================
              FAQ / AEO
          ================================================== */}

          <section
            className="bike-faq"
            aria-labelledby="bike-faq-title"
          >

            <header>
              <h2 id="bike-faq-title">
                Frequently Asked Questions About Bike Rental in Udaipur
              </h2>
            </header>

            {faqItems.map((item) => (
              <article
                className="faq-item"
                key={item.question}
              >

                <h3>
                  {item.question}
                </h3>

                <p>
                  {item.answer}
                </p>

              </article>
            ))}

          </section>

        </section>

      </main>
    </>
  );
}